import clsx from 'clsx'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { Button, BUTTON_COLOR } from '../../../../../../atoms'
import { Modal } from '../../../../../../molecules'

interface IModalDeclineBookingProps {
  isOpenModal: boolean
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  ownerDeclinedQuotation: {
    callback: () => void
    isLoading: boolean
  }
}

const DeclineQuotationModal = ({
  isOpenModal,
  setIsOpenModal,
  ownerDeclinedQuotation,
}: IModalDeclineBookingProps) => {
  const intl = useIntl()
  return (
    <Modal
      title={intl.formatMessage({
        id: 'ui.DeclineQuotationModal.modalTitle',
        defaultMessage: 'Refuser la demande ?',
      })}
      isOpen={isOpenModal}
      styleHeader={{
        borderBottom: '1px solid lightgray',
        marginBottom: '20px',
      }}
      closeModal={() => setIsOpenModal(false)}
      footerStyle={{ borderTop: '1px solid lightgray', marginBottom: '20px' }}
      customFooter={
        <div className={s.container}>
          <Button
            className={clsx(s.button, s.backButton)}
            color={BUTTON_COLOR.WHITE}
            onClick={() => setIsOpenModal(false)}
          >
            <FormattedMessage
              id='ui.DeclineQuotationModal.goBack'
              defaultMessage='Revenir en arrière'
            />
          </Button>
          <Button
            className={clsx(s.button)}
            color={BUTTON_COLOR.RED}
            onClick={async () => {
              await ownerDeclinedQuotation.callback()
              setIsOpenModal(false)
            }}
            loading={ownerDeclinedQuotation.isLoading}
          >
            <FormattedMessage
              id='ui.DeclineQuotationModal.declineQuote'
              defaultMessage='Refuser la demande'
            />
          </Button>
        </div>
      }
    >
      <p>
        <FormattedMessage
          id='ui.DeclineQuotationModal.confirmDeclineQuote'
          defaultMessage='Êtes-vous sûr de vouloir refuser la demande ?'
        />
      </p>
    </Modal>
  )
}

export default DeclineQuotationModal
